import { useExecuteSystemPresetMutation } from '../../../../../store/ai/aiExecute'
import { useCallback } from 'react'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { FormTask } from '../AddTaskToCRMModal'

export interface TaskMergerResults {
  subject: string
  description: string
}

export interface TaskMergerRequest {
  subject: string
  description: string
}

export const useMergeTasks = () => {
  const [executeSystemPreset] = useExecuteSystemPresetMutation()
  const accountId = useAppSelector(selectAccountId)

  return useCallback(
    async (tasksToMerge: FormTask[]) => {
      try {
        const taskMergeRequest: TaskMergerRequest[] = tasksToMerge.map((task) => ({
          subject: task.task || '',
          description: task.description || '',
        }))
        const results = await executeSystemPreset({
          accountId: accountId,
          payload: {
            systemPresetName: 'task_merger',
            context: {
              tasks: taskMergeRequest,
            },
          },
        }).unwrap()
        if (!results.length || !results[0].result || results[0].result.type !== 'structuredSummary') {
          return null
        }
        return results[0].result.result as unknown as TaskMergerResults
      } catch (e) {
        console.error(e)
        return null
      }
    },
    [accountId, executeSystemPreset],
  )
}
